export default {
    create_account_btn: 'Create Account',
    globals: {
        more_platforms: 'More Platforms coming soon',
        coming_soon: 'Coming soon',
    },
    buttons: {
        edit: 'edit',
        delete: 'delete',
    },
    alerts: {
        info: {
            part_one: 'Here you can connect your warehouses accounts\n' +
                'with supported Affiliate Networks and Fulfillment centers, to send them your orders automatically by API. You\n' +
                'can can connect one warehouse with one platform by API. Please see',
            part_two: 'this tutorial',
            part_three: 'or more information.',
        }
    },
    dialogs: {
        delete: {
            title: '',
            content: ''
        }
    },
    sdks: {
        cod_network: {
            title: 'COD Network (Seller/Drop)',
            fields: {
                affiliate_api_key: {
                    title: 'Affiliate API Key',
                    placeholder: 'Paste API Key here'
                },
                seller_api_token: {
                    title: 'Seller API Token',
                    placeholder: 'Paste API Token here'
                }
            },
            notes: {
                lead_info: 'Webhook for leads',
                order_info: 'Webhook for orders',
            }
        },
        eco_manager: {
            title: 'ecomanager.dz (Algeria)',
            fields: {
                store_name: {
                    title: 'Store Name',
                    placeholder: 'Your store name'
                },
                token: {
                    title: 'Bearer token',
                    placeholder: 'Paste token here'
                },
                send_order_on: {
                    title: 'Send order On',
                    placeholder: 'Send order On',
                    options: {
                        pending: 'Pending',
                        confirmed: 'Confirmed',
                    }
                },
                wilaya: {
                    title: 'Wilaya Name (optional)',
                    placeholder: 'The Wilaya Name'
                },
                commune: {
                    title: 'Commune Name (optional)',
                    placeholder: 'The Commune Name'
                }
            }
        },
        islaffiliate: {
            title: 'Islaffiliate - Affiliate Network',
            fields: {
                api_key: {
                    title: 'X-API-KEY',
                    placeholder: 'Paste API Key here',
                },
                user_id: {
                    title: 'X-USER-ID',
                    placeholder: 'Paste User Id here',
                },
            }
        },
        offersify: {
            title: 'Offersify - Affiliate Network',
            fields: {
                api_key: {
                    title: 'X-API-KEY',
                    placeholder: 'Paste API Key here',
                },
                user_id: {
                    title: 'X-USER-ID',
                    placeholder: 'Paste User Id here',
                },
            }
        },
        afrique_cod: {
            title: 'AfriqueCOD (Seller)'
        },
        cod_in_africa: {
            title: 'CODInAfrica (Seller)',
            fields: {
                api_key: {
                    title: 'Api Key',
                    placeholder: 'XXXXXXXXXX'
                },
                api_key_secret: {
                    title: 'Api Secret',
                    placeholder: 'XXXXXXXXXX'
                }
            }
        },
        prime_cod: {
            title: 'PrimeCOD (Seller/Drop)',
            fields: {
                token: {
                    title: 'Bearer token',
                    placeholder: 'XXXXXXXXXX'
                }
            }
        },
        ship_box: {
            title: 'ShipBox (Seller)',
            fields: {
                api_key: {
                    title: 'Api Key',
                    placeholder: 'XXXXXXXXXX'
                },
                api_key_secret: {
                    title: 'Api Secret',
                    placeholder: 'XXXXXXXXXX'
                }
            }
        },
        shipsen: {
            title: 'Shipsen (Seller)',
            fields: {
                api_key: {
                    title: 'Api Key',
                    placeholder: 'XXXXXXXXXX'
                },
                api_key_secret: {
                    title: 'Api Secret',
                    placeholder: 'XXXXXXXXXX'
                }
            }
        },
    },
    table: {
        account_id: 'Account Id',
        account_name: 'Account Name',
        account_role: 'Account Type',
        sdk_name: 'Platform',
        status: 'Status',
        actions: 'Actions'
    },
    dialog: {
        delete: {
            title: '',
            content: ''
        }
    },
    form: {
        update_account: {
            title: 'Update Account'
        },
        create_account: {
            title: 'Create Account'
        },
        fields: {
            account: {
                title: 'Warehouse',
                placeholder: 'Select a warehouse',
            },
            sdk: {
                title: 'Network Api'
            },
            auth_data: {
                title: 'Authorization Data *'
            },
            settings: {
                options: {
                    bearer: {
                        content: {
                            title: 'Bearer Token'
                        }
                    },
                    basic: {
                        username: {
                            title: 'Username'
                        },
                        password: {
                            title: 'Password'
                        }
                    }
                }
            },
            custom_data: {
                title: 'Custom Data',
                form: {
                    key_value: {
                        title: 'Key/Value List',
                        item: {
                            title: 'Key/Value',
                            form: {
                                key: {
                                    title: 'Key'
                                },
                                type: {
                                    options: {
                                        text: 'Text',
                                        list: 'List'
                                    }
                                },
                                value: {
                                    title: 'Value'
                                }
                            }
                        },
                        alert: 'No values added',
                        button_add: 'Add'
                    }
                }
            },
            notes: {
                title: 'Notes',
                no_notes: 'No notes available for this api.',
                no_sdk: 'No api selected'
            }
        },
        create_btn: 'Create Account',
        save_btn: 'Save Account',
        cancel_btn: 'Cancel',
    }
}